import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import type { AcademicYear as AcademicYearType } from '../../types';
import styles from './legend.module.css';

export type LegendProps = {
    academicYears: AcademicYearType[];
    isCourse?: boolean;
};

export const Legend = ({ academicYears, isCourse }: LegendProps) => {
    const { t } = useTranslation();
    const items = academicYears.flatMap((academicYear) => academicYear.semesters.flatMap((semester) => semester.items));
    const hasCourses = items.some((item) => item.type === 'course' && item.variant === 'Course');
    const hasWebinars = items.some((item) => item.type === 'course' && item.variant === 'Webinar');
    const hasElectives = items.some(
        (item) => item.type === 'opportunities' || (item.type === 'course' && item.variant === 'Elective'),
    );

    const legends = [
        hasCourses && {
            label: t(isCourse ? 'legend.modules' : 'legend.courses'),
            swatch: styles.swatchCourse,
        },
        hasWebinars && { label: t('legend.webinars'), swatch: styles.swatchWebinar },
        hasElectives && { label: t('legend.electives'), swatch: styles.swatchElective },
    ].filter(Boolean) as { label: string; swatch: string }[];

    if (legends.length <= 1) return null;

    return (
        <ul className={styles.legend}>
            {legends.map(({ label, swatch }) => (
                <li key={label} className={styles.legendItem}>
                    <span aria-hidden='true' className={classNames(styles.swatch, swatch)} />
                    {label}
                </li>
            ))}
        </ul>
    );
};
